// Based on https://gist.github.com/simonberger/13d3a416cdf3e72b5a46b031a9fb997d
class EventSystem {
  queue = {};

  publish(eventId, data) {
    if (eventId && this.queue[eventId]) {
      this.queue[eventId].forEach((callback) => {
        if (typeof callback === "function") {
          callback(data);
        }
      });
    }
  }

  subscribe(eventId, callback) {
    if (eventId && callback) {
      if (!this.queue[eventId]) {
        this.queue[eventId] = [];
      }

      this.queue[eventId].push(callback);
    }
  }

  //  the callback parameter is optional. Without it the whole eventId will be removed, instead of
  // just one subscription. Enough for simple implementations
  unsubscribe(eventId, callback) {
    if (this.queue[eventId]) {
      if (callback) {
        this.queue[eventId] = this.queue[eventId].filter((event) => {
          return event !== callback;
        });
      } else {
        delete this.queue[eventId];
      }
    }
  }
}

//  singleton
const eventSystem = new EventSystem();

/**
 * Expose only helper methods and not the event system itself,
 * to allow for unified subcribe/publish API
 * (e.g. processing action strings into event names and values)
 */

export function publish(eventId, eventValue) {
  if (eventId) {
    eventSystem.publish(eventId, eventValue);
  }
}

export function subscribe(eventId, callback) {
  eventSystem.subscribe(eventId, callback);
}

export function unsubscribe(eventId, callback) {
  eventSystem.unsubscribe(eventId, callback);
}
